// removed by extract-text-webpack-plugin
module.exports = {"nowPlaying":"src-components----nowplaying-module---nowPlaying---MOvtb","song":"src-components----nowplaying-module---song---1Tf6A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/nowplaying.module.css
// module id = 132
// module chunks = 35783957827783 213720915766396